import { toID, type ID } from './battle-dex';

/** Eternity format aliases → canonical id from |formats| (toID of format name). */
export const ETERNITY_FORMAT_ALIASES: { [alias: string]: ID } = {
	ussb: 'gen9championsmsb',
	ultimatestaffbros: 'gen9championsmsb',
	gen9ultimatestaffbros: 'gen9championsmsb',
	msb: 'gen9championsmsb',
	championsmsb: 'gen9championsmsb',
};

/** Resolve challenge/search alias to the id listed in |formats| (no duplicate BattleFormats entries). */
export function resolveEternityFormatId(format: string): ID {
	let name = format;
	const ruleSep = name.indexOf('@@@');
	if (ruleSep >= 0) name = name.slice(0, ruleSep);
	let id = toID(name);
	if (ETERNITY_FORMAT_ALIASES[id]) id = ETERNITY_FORMAT_ALIASES[id];
	if (window.BattleFormats?.[id]) return id;
	const fromName = toID(name);
	if (fromName && window.BattleFormats?.[fromName]) return fromName;
	return id;
}

/** Global compatibility name consumed by the legacy script-based client build. */
export function resolveEternityFormat(format: string): ID {
	return resolveEternityFormatId(format);
}
